import script from "./SelectionToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionToolbar.vue?vue&type=script&setup=true&lang=js"

import "./SelectionToolbar.vue?vue&type=style&index=0&id=20371a30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20371a30"]])

export default __exports__